var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as search from '@debbie/cortex/dist/api/search';
import React from 'react';
import THEME from '../theme';
import moment from 'moment';
import CaseStatus from '../components/CaseStatus';
const m = (s) => !!(s && ['full', 'partial'].includes(s));
export const searchAll = (lang, ...searchArgs) => __awaiter(void 0, void 0, void 0, function* () {
    const q = searchArgs[0];
    if ((q && q.length <= 2) || !q)
        return [];
    const re = yield search.all(...searchArgs);
    return re.hits
        ? re.hits.map((result) => {
            var _a, _b, _c, _d, _e, _f;
            let subheader = result._highlightResult.creditorName.value;
            if (m((_a = result._highlightResult.address) === null || _a === void 0 ? void 0 : _a.matchLevel)) {
                subheader = result._highlightResult.address.value;
            }
            else if (m((_b = result._highlightResult.voucherReferenceIds) === null || _b === void 0 ? void 0 : _b.matchLevel)) {
                subheader = `${lang.search.voucherReferenceId}: ${result._highlightResult.voucherReferenceIds.value}`;
            }
            else if (m((_c = result._highlightResult.phone) === null || _c === void 0 ? void 0 : _c.matchLevel)) {
                subheader = `${lang.search.phone}: ${result._highlightResult.phone.value}`;
            }
            else if (m((_d = result._highlightResult.cvr) === null || _d === void 0 ? void 0 : _d.matchLevel)) {
                subheader = `${lang.search.cvr}: ${result._highlightResult.cvr.value}`;
            }
            else if (m((_e = result._highlightResult.cpr) === null || _e === void 0 ? void 0 : _e.matchLevel)) {
                subheader = `${lang.search.cpr}: ${result._highlightResult.cpr.value}`;
            }
            else if (m((_f = result._highlightResult.email) === null || _f === void 0 ? void 0 : _f.matchLevel)) {
                subheader = result._highlightResult.email.value;
            }
            return {
                heading: (React.createElement("div", { style: { display: 'inline-block' } },
                    React.createElement("span", { dangerouslySetInnerHTML: {
                            __html: result._highlightResult.name.value,
                        } }),
                    ' ',
                    React.createElement(CaseStatus, { status: result.status }))),
                key: result.objectID,
                small: (React.createElement("div", { dangerouslySetInnerHTML: {
                        __html: `${result._highlightResult.creditorReferenceId
                            ? result._highlightResult.creditorReferenceId.value
                            : ''} ${result._highlightResult.migratedId &&
                            result._highlightResult.migratedId.value
                            ? `[${lang.search.migratedId}: ${result._highlightResult.migratedId &&
                                result._highlightResult.migratedId.value}] `
                            : ''} #${result._highlightResult.caseSeqId.value}`,
                    } })),
                supplementary: subheader
                    ? [
                        {
                            header: (React.createElement("span", { style: { float: 'left' }, dangerouslySetInnerHTML: {
                                    __html: subheader,
                                } })),
                            small: moment(result.createdAt).format(THEME.DATE_FORMAT),
                        },
                    ]
                    : undefined,
                returnData: result,
            };
        })
        : [];
});
//# sourceMappingURL=index.js.map